import { jsx } from 'panel';
import { UserIconEl } from 'common/widgets/user-icon';
import { ModalEl } from 'common/components/modal';
import { ButtonEl } from 'common/components/button';
import { IconSizeType } from 'common/constants';
import { ButtonTheme } from 'common/components/button/constants';
export function template() {
  return jsx("div", {
    sel: '.avatar-upload-container'
  }, jsx("div", {
    sel: '.avatar'
  }, jsx(UserIconEl, {
    attrs: {
      elref: "avatarUserIcon",
      id: this.attr("id"),
      name: this.attr("name"),
      size: IconSizeType.XL,
      'img-src': this.helpers.getAvatarUrl()
    }
  }), jsx("input", {
    attrs: {
      elref: "fileInput",
      type: "file",
      style: "display: none;",
      accept: "image/png, image/jpeg"
    },
    hook: {
      insert: this.helpers.fileInputInserted
    },
    on: {
      change: () => this.helpers.handleFileInputChange()
    }
  }), jsx(ButtonEl, {
    sel: '.upload-button',
    attrs: {
      elref: "uploadButton",
      theme: ButtonTheme.Primary,
      icon: "edit"
    },
    on: {
      click: this.helpers.handleUploadClick
    }
  })), this.attr("hide-name") ? null : jsx("div", {
    sel: '.name'
  }, this.attr("name")), jsx(ModalEl, {
    attrs: {
      closeable: !this.state.isEditingImage,
      open: this.state.isUploadModalOpen
    },
    on: {
      change: ev => this.helpers.handleModalChange(ev)
    }
  }, jsx("div", {
    sel: '.upload-avatar-modal'
  }, jsx("div", {
    sel: '.title'
  }, "Update Profile Photo"), jsx("div", {
    sel: '.avatar-editor'
  }, jsx("img", {
    sel: '#avatar-image',
    attrs: {
      src: this.state.sourceImage || ""
    },
    hook: {
      insert: this.helpers.avatarImgElementInserted
    }
  })), jsx("div", {
    sel: '.actions'
  }, jsx(ButtonEl, {
    attrs: {
      elref: "saveAvatarButton",
      theme: ButtonTheme.Primary
    },
    on: {
      click: this.helpers.handleImageCropped
    }
  }, "Save")))));
}